<template>
  <div>
    <nav class="border-b border-gray-300 px-2 md:px-0 py-2">
      <div class="flex justify-between items-center">
        <div class="">
          <div class="hidden md:flex text-sx">
            <div>Home</div>
            <span class="mx-2">/</span>
            <div>organizations</div>
          </div>
          <div class="text-xl">
            Organizations
          </div>
        </div>
        <div class="">
          <router-link v-if="$store.getters.can('create_organizations')"
                       class="py-1 px-2 md:py-2 md:px-4 bg-teal-500 md:font-semibold text-white hover:border-transparent rounded float-right"
                       :to="{name:'create_organization'}">New organization
          </router-link>
        </div>
      </div>
    </nav>
    <div class="py-4">
      <div class="border rounded mt-4 overflow-auto">
        <div class=" overflow-auto m-4">
          <OrganizationsComponent admin-status=""/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OrganizationsComponent from "../../components/OrganizationsComponent";

export default {
  name: "Organizations",
  components: {OrganizationsComponent},
  data() {
    return {}
  },
  mounted() {
  },
  methods: {}
}
</script>

<style scoped>

</style>